import { UserProfileView } from '@mark43/cad-api';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';

export function useCurrentUser(): UserProfileView {
    const userProfileView = useBootstrapState()?.userProfileView;
    if (!userProfileView) {
        throw new Error('Unexpectedly did not find userProfileView on bootstrap state');
    }
    return userProfileView;
}
